import { useState, useEffect } from 'react';
import { Box, Text } from '@mantine/core';

function PowerupCard({ powerup, selected, onSelect, disabled, dealDelay = 0, forceRevealed = false }) {
  const [revealed, setRevealed] = useState(forceRevealed);

  useEffect(() => {
    if (forceRevealed) {
      setRevealed(true);
      return;
    }
    const timer = setTimeout(() => setRevealed(true), dealDelay);
    return () => clearTimeout(timer);
  }, [dealDelay, forceRevealed]);

  const isPenalty = powerup.type === 'penalty';
  const cardBg = isPenalty ? '#1a0a0a' : '#0a1a0a';
  const accentColor = powerup.color;

  return (
    <Box
      onClick={() => !disabled && revealed && onSelect?.(powerup)}
      style={{
        perspective: '600px',
        width: 110,
        height: 160,
        flexShrink: 0,
        cursor: disabled || !revealed ? 'default' : 'pointer',
      }}
    >
      <Box
        style={{
          position: 'relative',
          width: '100%',
          height: '100%',
          transformStyle: 'preserve-3d',
          transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
          transform: revealed ? 'rotateY(0deg)' : 'rotateY(180deg)',
        }}
      >
        {/* Card Front (face-up) */}
        <Box
          style={{
            position: 'absolute',
            inset: 0,
            backfaceVisibility: 'hidden',
            borderRadius: 12,
            backgroundColor: cardBg,
            border: selected
              ? `3px solid ${accentColor}`
              : `2px solid ${accentColor}44`,
            boxShadow: selected
              ? `0 0 20px ${accentColor}88, 0 4px 16px rgba(0,0,0,0.5)`
              : '0 4px 12px rgba(0,0,0,0.4)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            padding: 10,
            transition: 'box-shadow 0.2s, border-color 0.2s, transform 0.15s',
            transform: selected ? 'translateY(-4px) scale(1.04)' : 'none',
          }}
        >
          {/* Icon */}
          <Box
            style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              backgroundColor: `${accentColor}22`,
              border: `2px solid ${accentColor}66`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <i
              className={`fa-solid ${powerup.icon}`}
              style={{ fontSize: '1.4rem', color: accentColor }}
            />
          </Box>

          {/* Name */}
          <Text
            size="xs"
            fw={700}
            ta="center"
            style={{ color: '#fff', lineHeight: 1.2, fontSize: '0.72rem' }}
          >
            {powerup.name}
          </Text>

          {/* Description */}
          <Text
            size="xs"
            ta="center"
            style={{ color: '#aaa', lineHeight: 1.2, fontSize: '0.6rem' }}
          >
            {powerup.description}
          </Text>
        </Box>

        {/* Card Back (face-down) */}
        <Box
          style={{
            position: 'absolute',
            inset: 0,
            backfaceVisibility: 'hidden',
            transform: 'rotateY(180deg)',
            borderRadius: 12,
            background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
            border: '2px solid #334',
            boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {/* Back pattern */}
          <Box style={{ opacity: 0.3 }}>
            <i className="fa-solid fa-bolt" style={{ fontSize: '2.5rem', color: '#fff' }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default PowerupCard;
